/**
 * 多个页面会使用的公共接口
 */
import { get, post } from '@/common/request/index';
/**
 * 品牌列表
 * https://yapi.lanhanba.com/project/307/interface/api/33554
 */

export function getBrandList(params = {}) {
  return get('/requirement/selection/brandList', params, { needCancel: false });
}
/**
 * 需求筛选项集合
 * https://yapi.lanhanba.com/project/307/interface/api/33552
 */

export function getSelection(params = {}) {
  return get('/requirement/selection', params, { needCancel: false });
}

/**
 * 发布前检查
 * https://yapi.lanhanba.com/project/307/interface/api/34255
 */
export function publishCheck(params) {
  return get('/requirement/publishCheck', params, true);
}
/**
 * 草稿-发布
 * https://yapi.lanhanba.com/project/307/interface/api/33529
 */
export function postPublish(params) {
  return post('/requirement/publish', params, true);
}
/**
 * 需求评分
 * https://yapi.lanhanba.com/project/307/interface/api/42678
 */
export function getRequirementLevel(id) {
  return get('/requirement/level/score', id, { needHint: true, isMock: false });
}
/**
 * 结束需求
 * https://yapi.lanhanba.com/project/307/interface/api/34303
 */
export function finishPublish(params) {
  return post('/requirement/finish', params, true);
}

/**
 * 指派
 * https://yapi.lanhanba.com/project/307/interface/api/33530
 */
export function postAssign(params) {
  return post('/requirement/assign', params, true);
}

/**
 * 根据需求id获取默认群成员
 * https://yapi.lanhanba.com/project/307/interface/api/69327
 */
export function getGroupChatDefaultMember(params?: any) {
  return get('/wechat/groupChat/defaultMember', { ...params }, true);
}

/**
 * 再次获取推荐编辑详情
 * https://yapi.lanhanba.com/project/307/interface/api/92763
 */
export function getReferrerAgainEditDetail(params: { id: number }) {
  return post('/requirement/referrerAgain/editDetail', params, { isMock: false });
}

/**
 * 转交指派
 * https://yapi.lanhanba.com/project/307/interface/api/34232
 */
export function transferAssign(params) {
  return post('/requirement/transfer/assigner', params, true);
}

/**
 * 修改推荐人
 * https://yapi.lanhanba.com/project/307/interface/api/34272
 */
export function postUpdateAssign(params) {
  return post('/requirement/update/assign', params, true);
}

/**
 * 需求详情
 * https://yapi.lanhanba.com/project/307/interface/api/33526
 */
export function getDetail(params) {
  return get('/requirement/detail', params, { needHint: true, isMock: false });
}
/**
 * 修改需求项目最低毛利率
 * https://yapi.lanhanba.com/project/307/interface/api/41250
 */
export function updateGrossProfit(params) {
  return post('/requirement/projectGrossProfit/update', params, true);
}

/**
 * 需求详情
 * https://yapi.lanhanba.com/project/307/interface/api/34460
 */
export function getTabs(params) {
  return get('/requirement/getTabs', params, true);
}

/**
 * 删除需求
 * https://yapi.lanhanba.com/project/307/interface/api/33929
 */

export function getDelete(params = {}) {
  return get('/requirement/delete', params, true);
}
/**
 * 商圈列表
 * https://yapi.lanhanba.com/project/307/interface/api/33801
 */

export function getBusinessCircleList(params = { cityIds: [] }) {
  return get('/requirement/selection/businessCircleList', {
    cityIds: params.cityIds.reduce((arr: any, item: any) => {
      arr.push(item.value);
      return arr;
    }, []).join(',')
  }, true);
}

/**
 * 场地列表
 * https://yapi.lanhanba.com/project/307/interface/api/33559
 */
export function postPlaceList(params = {}) {
  return post('/recommend/selection/placeList', params, true);
}
/**
 * 下拉框 - 场地列表
 * https://yapi.lanhanba.com/project/307/interface/api/33559
 */

export function postRequirementPlaceList(params = {}) {
  return post('/requirement/selection/placeList', params, true);
}
/**
 * 查询展位下的供给
 * https://yapi.lanhanba.com/project/307/interface/api/34258
 */

export function getProvide(params = {}) {
  return get('/supply/query', params, true);
}
/**
 * 查询供应商
 * https://yapi.lanhanba.com/project/307/interface/api/34265
 */

export function getSupplier(params = {}) {
  return get('/supplier/query', params, true);
}
/**
 * 询展位类型
 * https://yapi.lanhanba.com/project/307/interface/api/33924
 */

export function searchCategory(params = {}) {
  return get('/spot/searchCategory', params, true);
}

/**
 * 判断需求是否超时未反馈【用于详情弹框使用】
 * https://yapi.lanhanba.com/project/307/interface/api/67990
 */
export function getRequirementIsOverTime(params) {
  return get('/requirement/isOverTime', params, { isMock: false });
}

/**
 * 需求推荐进度
 * https://yapi.lanhanba.com/project/307/interface/api/69586
 */
export function getRequirementProcessRcmd(params) {
  return get('/requirement/process/rcmd', params, { isMock: false });
}

/**
 * 根据ids查询下拉项
 * https://yapi.lanhanba.com/project/307/interface/api/69838
 */
export function getRequirementSelectionByIds(params) {
  return post('/requirement/selection/byIds', params, { isMock: false });
}

/**
 * 需求信息核对详情
 * https://yapi.lanhanba.com/project/307/interface/api/70342
 */
export function getRequirementDetailCheckInfo(params) {
  return get('/requirement/detail/checkInfo', params, { isMock: false });
}

/**
 * 创建群聊【根据需求id】
 * https://yapi.lanhanba.com/project/307/interface/api/70783
 */
export function getWechatGroupChatCreate(params) {
  return get('/wechat/groupChat/create', params, { isMock: false });
}


/**
 * 垫款按钮展示
 * https://yapi.lanhanba.com/project/29/interface/api/71595
 */
export function getExternalAdvanceButtons(params) {
  return get('/external/lcn/advance/buttons', params, { proxyApi: '/lhbphp-api', isMock: false, mockId: 29 });
}

// /**
//  * 企业是否存在额度及进行中资质审批
//  * https://yapi.lanhanba.com/project/29/interface/api/71602
//  */
// export function getExternalAdvanceCompanyBase(params) {
//   return get('/external/lcn/advance/company/base', params, { proxyApi: '/lhbphp-api', isMock: false, mockId: 29 });
// }

/**
 * 发起垫款资质申请基本信息
 * https://yapi.lanhanba.com/project/29/interface/api/71609
 */
export function getExternalAdvanceCompanyApplyBase(params) {
  return get('/external/lcn/advance/company/apply/base', params, { proxyApi: '/lhbphp-api', isMock: false, mockId: 29 });
}

/**
 * 查看垫款流程
 * https://yapi.lanhanba.com/project/29/interface/api/71616
 */
export function getExternalAdvanceDetail(params) {
  return get('/external/lcn/advance/detail', params, { proxyApi: '/lhbphp-api', isMock: false, mockId: 29 });
}

/**
 * 修改需求联系人
 * https://yapi.lanhanba.com/project/307/interface/api/72316
 */
export function postRequirementUpdateContact(params) {
  return post('/requirement/update/contact', params, { isMock: false });
}


/**
 * 获取推荐明细编辑详情
 * https://yapi.lanhanba.com/project/307/interface/api/73254
 */
export function getRecommendTaskEdit(params) {
  return post('/recommendTask/edit', params, { isMock: false });
}


/**
 * 动态表单配置详情【编辑】
 * https://yapi.lanhanba.com/project/307/interface/api/73590
 */
export function getDynamicTemplateEditDetail(params) {
  return post('/dynamic/template/editDetail', params, { isMock: false });
}

/**
 * 动态表单配置详情（模板）
 * https://yapi.lanhanba.com/project/307/interface/api/73660
 */
export function getDynamicTemplateDetail(params) {
  return post('/dynamic/template/detail', params, { isMock: false });
}

/**
 * 推荐明细详情【修改】（模板值）
 * https://yapi.lanhanba.com/project/307/interface/api/73653
 */
export function getRecommendEditDetail(params) {
  return get('/recommend/editDetail', params, { isMock: false });
}

/**
 * 动态下拉框组件-下拉框搜索
 * https://yapi.lanhanba.com/project/321/interface/api/64091
 */
export function getDropDownListSearch(params) {
  return post('/dropDownList/search', params, { isMock: false, needCancel: false, proxyApi: '/resserv', mockId: 321 });
}

/**
 * 推荐明细修改
 * https://yapi.lanhanba.com/project/307/interface/api/73667
 */
export function postRecommendUpdate(params) {
  return post('/recommend/update', params, { isMock: false });
}

/**
 * 获取资拓区域分布
 * https://yapi.lanhanba.com/project/307/interface/api/92809
 */

export function getDistributionData(params) {
  return post('/recommendTask/resourceDistribution', params, { isMock: false });
}

/**
 * 生成场地清单-new
 * https://yapi.lanhanba.com/project/307/interface/api/73835
 */
export function postPlaceListCreate(params) {
  return post('/v2/placeList/create', params, { isMock: false });
}


/**
 * 场地推荐列表
 * https://yapi.lanhanba.com/project/307/interface/api/53752
 */
export function getRecommendPageList(params) {
  return post('/recommend/pageList', params, { isMock: false });
}

/**
 * 报价单-快速创建报价单
 * https://yapi.lanhanba.com/project/307/interface/api/74297
 */
export function postQuoteFastCreateBatch(params) {
  return post('/quote/fastCreateBatch', params, { isMock: false });
}

/**
 * 意向点位匹配可带入数据列表
 * https://yapi.lanhanba.com/project/307/interface/api/74920
 */
export function postIntentResourceMatchChangePropertyList(params) {
  return post('/requirement/intentResource/match/changePropertyList', params, { isMock: false });
}

/**
 * 匹配资源库点位
 * https://yapi.lanhanba.com/project/307/interface/api/53766
 */
export function postRequirementIntentResourceMatch(params) {
  return post('/requirement/intentResource/match', params, { isMock: false });
}

/**
 * 资源库点位无法匹配
 * https://yapi.lanhanba.com/project/307/interface/api/53962
 */
export function postRequirementIntentResourceNoMatch(params) {
  return post('/requirement/intentResource/noMatch', params, { isMock: false });
}

/**
 * 识别意向资源（场地、点位）
 * https://yapi.lanhanba.com/project/307/interface/api/74927
 */
export function postRecognizeIntentResource(params) {
  return post('/recognize/intentResource', params, { isMock: true });
}

/**
 * 获取任务页按钮列表
 * https://yapi.lanhanba.com/project/307/interface/api/33911
 */
export function getRecommendTaskRecommendButtons(params) {
  return get('/recommendTask/recommendButtons', params, { isMock: false });
}

/**
 * 意向场地匹配列表
 * https://yapi.lanhanba.com/project/307/interface/api/91018
 */
export function getIntentResourcePreMatchList(params) {
  return post('/requirement/intentResource/preMatchList', params, { isMock: false });
}

/**
 * 意向场地匹配保存
 * https://yapi.lanhanba.com/project/307/interface/api/91027
 */
export function getIntentResourcePreMatch(params) {
  return post('/requirement/intentResource/preMatch', params, { isMock: false });
}

/**
 * 获取匹配场地对应的推荐人
 * https://yapi.lanhanba.com/project/307/interface/api/91306
 */
export function getIntentResourceQueryMatchUser(params) {
  return post('/requirement/intentResource/queryMatchUser', params, { isMock: false });
}

/**
 * 批量拒绝
 * https://yapi.lanhanba.com/project/307/interface/api/91072
 */
export function getIntentResourceBatchReject(params) {
  return post('/requirement/intentResource/batchReject', params, { isMock: false });
}

/**
 * 场地分页列表（包含子点位）
 * https://yapi.lanhanba.com/project/307/interface/api/71651
 */
export function postPlacePageListTree(params) {
  return post('/place/pageList/tree', params, { isMock: false });
}

/**
 * 场地分页列表（不包含子点位）
 * https://yapi.lanhanba.com/project/307/interface/api/91972
 */
export function postPlacePageList(params) {
  return post('/place/pageList', params, { isMock: false });
}



/**
 * 获取目标场景选项
 */
export function getSpotPosition(params) {
  return get('/spot/spotPosition', params, { isMock: false });
}

